import httpApi from '../api/httpApi';
import useSWR from 'swr';
import { MyQuotation } from '../../models/quotations/MyQuotation';

const QUOTES_URL = '/api/v1/quotes';

const useMyQuotationSWR = (quoteId: string) => {
    const fetch = (query): Promise<MyQuotation> => {
        return httpApi
            .get<{ quote: MyQuotation }>(query)
            .then((res) => {
                return res.getData().quote;
            })
            .catch((error) => {
                throw error;
            });
    };

    const { data, error, isLoading, mutate } = useSWR(
        QUOTES_URL + '/' + quoteId,
        fetch,
        {
            dedupingInterval: 600000, // 10min
            errorRetryCount: 3,
        }
    );

    return {
        quote: data ? data : null,
        isLoading: isLoading,
        isError: error,
        forceRefresh: mutate,
    };
};

export default useMyQuotationSWR;
